<div class="control has-icons-left has-icons-right mt-0 mb-2 fjrfhrhfrhfhru">
  <div class="multiselect-box mb-1">
    <div class="control">
      <div
        class="field is-grouped is-grouped-multiline pl-2 pt-2 mb-0"
        *ngIf="selectedSearchResults.length"
      >
        <div
          class="control mb-2"
          *ngFor="let selectedSearchResult of selectedSearchResults"
        >
          <div class="tags has-addons">
            <span class="tag is-link">{{ selectedSearchResult.label }}</span>
            <a
              class="tag is-delete"
              (click)="toggleItem(selectedSearchResult)"
              (keydown)="toggleItem(selectedSearchResult)"
              tabindex="0"
            ></a>
          </div>
        </div>
      </div>
    </div>
    <div class="multisearch-input-field is-relative">
      <input
        type="text"
        id="search-form-input"
        autocomplete="off"
        #searchInput
        class="input"
        [ngClass]="{ 'is-danger-bis': isError }"
        style="min-width: unset"
        placeholder="{{ placeholder || 'Search tools by name...' }}"
        (keyup)="onSearchInputKeyup($event)"
        [readonly]="selectedSearchResults.length >= maxSelectedSearchResults"
      />
      <span class="icon is-small is-left">
        <i class="fas fa-search has-text-grey-dark is-size-7"></i>
      </span>
      <ul
        class="box list mt-0 px-0 is-size-7 has-text-dark"
        *ngIf="showList && suggestedSearchResults.length"
      >
        <li
          *ngFor="let searchResult of suggestedSearchResults; let i = index"
          class="pointer mb-0"
          [ngClass]="{
            'is-active has-text-link has-background-primary-light':
              selectedSearchResults.indexOf(searchResult) > -1,
            'is-focused': focusedItemIndex === i
          }"
          (click)="toggleItem(searchResult)"
          (keydown)="toggleItem(searchResult)"
          tabindex="0"
        >
          <span innerHTML="{{ searchResult.label }}"></span>
        </li>
      </ul>
      <ul
        class="box list mt-0 px-0 is-size-7 has-text-dark"
        *ngIf="showList && !suggestedSearchResults.length"
      >
        <li class="is-flex is-flex-direction-column pointer bg-link-alpha10">
          <a
            class="button is-small is-transparent px-1 has-text-link is-bold"
            *ngIf="noResultLink"
            target="_blank"
            [routerLink]="noResultLink"
          >
            <i class="fa fa-plus-circle"></i>
            {{ noResultContent }}
          </a>
          <p class="my-0">
            <span *ngIf="!noResultLink" [routerLink]="noResultLink">
              {{ noResultContent }}
            </span>
          </p>
        </li>
      </ul>
    </div>
  </div>
</div>
